export const create = {
  form: {
    price: '価格/円',
    quantity: '仕入れ数量',
    name: '商品名(洗剤名)',
    submit: '新規追加',
    requirePrice: '価格/円を入力してください',
    requireQuantity: '仕入れ数量を入力してください',
    priceUnit: '円',
    quantityUnit: 'グラム',
    invalidLetters: '文字のみ入力できます。',
    invalidNumbers: '数字のみ入力できます。',
  },
  pageHeader: {
    title: '在庫履歴　新規追加画面',
    back: '戻る',
  },
}
